import { Contact, User } from 'displet-sdk-js';

export default {
  namespaced: true,

  actions: {
    /** @return {Promise<void>} */
    async fetchAgent({ commit, getters }) {
      const { agentId, hasAgent } = getters;

      if (hasAgent) {
        // exit early because the agent has already been loaded
        return;
      }

      if (!agentId) {
        // exit early because the contact does not have an agent
        return;
      }

      const agent = await User.findById(agentId);

      commit('setAgent', agent);
    },
  },

  state: {
    contact: new Contact(),
    agent: undefined,
  },

  getters: {
    contactTelephone(state) {
      return state.contact.getPrimary('phone_number')?.number;
    },
    contactName(state) {
      return state.contact.getName();
    },
    contactEmail(state) {
      return state.contact.email;
    },
    agentId(state) {
      return state.contact.user_id;
    },
    hasAgent(state) {
      return !!state.agent;
    },
    agentName(state) {
      return state.agent?.getName();
    },
    agentEmail(state) {
      return state.agent?.email;
    },
  },

  mutations: {
    /** @return {void} */
    setContact(state, value) {
      state.contact = value;
    },

    /** @return {void} */
    unsetContact(state) {
      state.contact = new Contact();
    },

    setAgent(state, value) {
      state.agent = value;
    },

    unsetAgent(state) {
      state.agent = undefined;
    },
  },
};
